import React, { useState, useEffect, useRef } from "react";
import { MapGIS, activeLayers } from "./webGIScomponents/mapGIS";
import Logo from "./triquetra-full-logo.svg";
import LoadingLogo from "./components/LoadingLogo";
import axios from "axios";
import "./WebGIS.css";
// import earth from "./google-earth.svg";
import ClearLayersButton from "./webGIScomponents/ClearLayersButton";
import PointcloudButton from "./webGIScomponents/PointcloudButton";
import JSONToDivs from "./webGIScomponents/JSONToDivs";
import AboutModal from "./webGIScomponents/AboutModal";
import LayerSearchbar from "./webGIScomponents/LayerSearchBar";
import ExternalComponentsLayers from "./webGIScomponents/ExternalComponentsLayers";
import ExternalComponentsButton from "./webGIScomponents/ExternalComponentsButton";
import LayerLegend from "./webGIScomponents/LayerLegend";
import StyleSwitcher from "./webGIScomponents/StyleSwitcher";
import Pointclouds from "./webGIScomponents/Poinclouds";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Climatology from "./webGIScomponents/Climatology";
import { useNavigate } from "react-router-dom";
import AccessibilityMenu from "./webGIScomponents/AccessibilityMenu";

import LoginPage from "./components/LoginPage";
import { faBroom } from "@fortawesome/free-solid-svg-icons";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

import {
  faMap,
  faLayerGroup,
  faTriangleExclamation,
  faShield,
  faXmark,
  faTemperatureHalf,
  faArrowRotateLeft,
  faUniversalAccess,
  faPlus, 
  faMinus,
} from "@fortawesome/free-solid-svg-icons";
import Tooltip from "@mui/material/Tooltip";
import { Button } from "@mui/material";
import FeatureInfo from "./webGIScomponents/FeatureInfo";
import FolderLayout from "./webGIScomponents/LayerCards/FolderLayout";
import Funding from "./components/Funding";
import Earth from "./webGIScomponents/Earth";
import { faHouse } from "@fortawesome/free-solid-svg-icons";

function WebGIS() {
  const [loadingVisible, setLoadingVisible] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [jsonTitleParts, setJsonTitleParts] = useState({}); // Store the JSON data here
  const [dataNew, setDataNew] = useState({}); // Store the JSON data here
  const [layerName, setLayerName] = useState(null);
  const [layerOpacity, setLayerOpacity] = useState(null);
  const [switchIsOn, setSwitchIsOn] = useState(false);
  const [buttonOn, setButtonOn] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [boundingBox, setBoundingBox] = useState({});
  const savedLayers = [];
  const host = process.env.REACT_APP_HOST;
  const [leftValue, setLeftValue] = useState("110%");
  const [bottomValue, setBottomValue] = useState("-20%");
  const [layerLeftValue, setLayerLeftValue] = useState("75px");
  const [searchTerm, setSearchTerm] = useState("");
  const [checkedAll, setCheckedAll] = useState(null);
  const [activeLayers, setActiveLayers] = useState([]);
  const [pointClouds, setClearPointClouds] = useState(false);
  const [loginAUTH, setLoginAUTH] = useState(false);
  const [layersThatWereSwitchedNames, setLayersThatWereSwitchedNames] =
    useState([]);
  const [climatologyRightValue, setClimatologyRightValue] = useState("-100%");
  const [earthRightValue, setEarthRightValue] = useState("-100%");
  const titlesObject = useRef();
  const [clearLayersWasClicked, setClearLayersWasClicked] = useState(false);
  const [mapStyleWasSwapped, setMapStyleWasSwapped] = useState(false);
  const [leftButtonsVisible, setLeftButtonsVisible] = useState(true);
  const mapRef = useRef();
  const navigate = useNavigate();

  const [accSettings, setAccSettings] = useState({
    highContrast: false,
    grayscale: false,
    fontSize: 1.0
  });
  const [isAccVisible, setIsAccVisible] = useState(false);

  const platformStyle = {
    filter: `${accSettings.grayscale ? "grayscale(100%) " : ""}${accSettings.highContrast ? "contrast(180%)" : ""}`,
    fontSize: `${accSettings.fontSize * 100}%`,
  };


  //--------------------------------------UseEffect for authentication check----------------------------------------------------------//
  useEffect(() => {
    axios
      .get(`${host}/checklogin`, { withCredentials: true })
      .then((response) => {
        console.log(response);
        const checkLogin = response.data;
        if (checkLogin === "loginTrue") {
          const loginContainer = document.getElementById("login-container");
          if (loginContainer) {
            loginContainer.style.display = "none";
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  //------------------------------------------------------------------------------------------------------------------------------------//

  const handleSearchTermChange = (input) => {
    setSearchTerm(input);
  };

  const toggleModal = () => {
    //for toggling the about button modal
    setIsModalVisible(!isModalVisible);
  };

  const toggleLeftButtons = () => {
    setLeftButtonsVisible(!leftButtonsVisible);
  };

  const toggleStyleSwitcher = () => {
    if (leftValue === "110%") {
      setLeftValue("calc(100% - 442px)"); // Change the Left value to 81%
    } else {
      setLeftValue("110%"); // Change it back to 100%
    }
  };

  const goToWebGIS = () => {
    window.location.href = "/webgis";
  };

  const resetApp = () => {
    // Reset UI panels
    setLeftValue("110%");
    setBottomValue("-20%");
    setLayerLeftValue("75px"); //???
    setClimatologyRightValue("-100%");
    setEarthRightValue("-100%");

    // Reset map-related values
    setLayerName(null);
    setLayerOpacity(null);
    setBoundingBox({});
    setSwitchIsOn(false);
    setButtonOn(false);

    // Reset layers
    setActiveLayers([]);
    setLayersThatWereSwitchedNames([]);
    setCheckedAll(null);
    setClearLayersWasClicked(true);

    // Reset search
    setSearchTerm("");

    // Reset loaded data view
    if (titlesObject.current) {
      makeDivs(titlesObject.current); // restore full folder structure
    }

    // Optionally: Fly map back to initial view
    // You may need to expose a reset function from MapGIS
    mapRef.current?.flyHome();
  };

  // useImperativeHandle(ref, () => ({
  //   flyHome() {
  //     map.current.flyTo({
  //       center: [23.77262921129215, 38.07445185628109],
  //       zoom: 15,
  //       pitch: 0,
  //       bearing: 0,
  //       duration: 1200,
  //     });
  //   },
  // }));

  const toggleLayerSwitcher = () => {
    if (layerLeftValue === "-208%") {
      setLayerLeftValue("75px"); // Change the Left value to 81%
    } else {
      setLayerLeftValue("-208%"); // Change it back to 100%
    }
  };
  const toggleClimatologySwitcher = () => {
    if (climatologyRightValue === "-100%") {
      setClimatologyRightValue("50px"); // Change the Left value to 81%
    } else {
      setClimatologyRightValue("-100%"); // Change it back to 100%
    }
  };
  const toggleEarth = () => {
    if (earthRightValue === "-100%") {
      setEarthRightValue("50px"); // Change the Left value to 81%
    } else {
      setEarthRightValue("-100%"); // Change it back to 100%
    }
  };
  const togglePointclouds = () => {
    if (bottomValue === "-20%") {
      setBottomValue("5px"); // Change the Left value to 81%
    } else {
      setBottomValue("-20%"); // Change it back to 100%
    }
  };

  const clearPointClouds = () => {
    setClearPointClouds(true);
  };

  async function loadManual() {
    try {
      const response = await axios.post(
        `${host}/getManual`,
        {},
        { responseType: "blob" }
      );

      // Check if the response contains data
      if (!response.data) {
        console.error("Empty response");
      }

      // Create a blob object from the response data
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });

      if (response.headers["content-type"] === "application/pdf") {
        // If it's a PDF, open it in a new tab
        const url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
        window.URL.revokeObjectURL(url);
        return true;
      } else {
        console.error("Not a PDF file");
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  const fetchData = async () => {
    try {
      const response = await axios.get(`${host}/GetCapabilities`);
      console.log(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle error if needed
    }
  };

  useEffect(() => {
    if (titlesObject.current) return;
    const fetchDataAndProcess = async () => {
      titlesObject.current = await fetchData();
      console.log(titlesObject.current, "initial data");
      const inputString = searchTerm;
      // console.log(titlesObject.current);
      makeDivs(titlesObject.current);

      setTimeout(() => {
        setLoadingVisible(false);
      }, 2500);
    };

    fetchDataAndProcess();
  }, []);

  useEffect(() => {
    if (!titlesObject.current) return;
    const filterArrayByTitle = (input, dataArray) => {
      return dataArray.filter((item) =>
        item.Title.toLowerCase().includes(input.toLowerCase())
      );
    };

    const filterArrayByName = (input, dataArray) => {
      return dataArray.filter((item) =>
        item.Name.toLowerCase().includes(input.toLowerCase())
      );
    };
    const inputString = searchTerm;

    console.log(filterArrayByName(inputString, titlesObject.current));

    // makeDivs(filterArrayByTitle(inputString, titlesObject.current));
    makeDivs(filterArrayByName(inputString, titlesObject.current));
  }, [searchTerm]);

  const makeDivs = (data) => {
    // console.log(data);
    const layersToSkip = [
      "triquetra:Les_Argilliez_layer_377",
      "triquetra:Les_Argilliez_layer_378",
      "triquetra:Ventotene_layer_379",
    ];
    if (typeof data === "object") {
      setDataNew({});
      const titles = Object.values(data);
      titles.forEach((item) => {
        if (layersToSkip.includes(item.Name)) return;
        const TitleParts = item.Title.split(":").map((s) => s.trim());
        let currentGroup = dataNew;

        for (let i = 0; i < TitleParts.length; i++) {
          const part = TitleParts[i];
          if (!currentGroup[part]) {
            currentGroup[part] =
              i === TitleParts.length - 1
                ? {
                    Name: item.Name,
                    Abstract: item.Abstract,
                    BoundingBox: item.BoundingBox,
                    Title: item.Title,
                  }
                : {};
          }
          currentGroup = currentGroup[part];
        }
      });
    } else {
      console.error("Invalid data format");
    }
    console.log(dataNew, "datanew");
    setJsonTitleParts(dataNew);
  };
  console.log(layersThatWereSwitchedNames);

  return (
    <div className="web-gis-platform" style={platformStyle}>
      {loadingVisible && <LoadingLogo />}
      {!loginAUTH && <LoginPage setLoginAUTH={setLoginAUTH} />}
      <header>
      <div className="header">
        <a href="./">
          <img src={Logo} alt="Logo" className="logo" />
        </a>
        
        <div className="manual-about">
          {/* New Accessibility Button */}
          <button className="about-button" onClick={() => setIsAccVisible(true)}>
              <FontAwesomeIcon icon={faUniversalAccess} style={{marginRight: "5px"}} />
              Accessibility
            </button>
          
          <button className="manual-button" onClick={loadManual}>Manual</button>
          <button className="about-button" onClick={toggleModal}>About</button>
        </div>
      </div>
    </header>

    <AccessibilityMenu 
        visible={isAccVisible} 
        onClose={() => setIsAccVisible(false)}
        settings={accSettings}
        setSettings={setAccSettings}
      />

      {isModalVisible && <AboutModal toggleModal={toggleModal} />}
      <div className="main-container">
        <div className="MapComponent">
          <MapGIS
            ref={mapRef}
            layerName={layerName}
            switchIsOn={switchIsOn}
            layerOpacity={layerOpacity}
            boundingBox={boundingBox}
            buttonOn={buttonOn}
            setButtonOn={setButtonOn}
            activeLayers={activeLayers}
            setActiveLayers={setActiveLayers}
            clearPointClouds={pointClouds}
          />
        </div>
        <Climatology
          climatologyRightValue={climatologyRightValue}
          toggleClimatologySwitcher={toggleClimatologySwitcher}
        />
        <Earth
          earthRightValue={earthRightValue}
          toggleEarthSwitcher={toggleEarth}
        />
        <div
          className={`left-side-buttons-container ${
            leftButtonsVisible ? "" : "left-side-buttons-hidden"
          }`}
        >
          {/* <div className="left-side-buttons-container"> */}
          <Tooltip
            title={
              <span style={{ fontSize: "13px" }}>
                <b>Toggle Layer Cards</b>
              </span>
            }
            placement="right"
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: "rgba( 83, 139, 34, 0.9)",
                  fontFamily: "Maven pro",
                  padding: "5px 10px",
                  "& .MuiTooltip-arrow": {
                    color: "rgba( 83, 139, 34, 0.9)",
                  },
                },
              },
            }}
            arrow
          >
            <button
              className="layer-layer-show"
              id="layer-show-button"
              onClick={() => {
                {
                  toggleLayerSwitcher();
                }
              }}
            >
              <FontAwesomeIcon icon={faLayerGroup} />
            </button>
          </Tooltip>
          <PointcloudButton togglePointclouds={togglePointclouds} />
          <ClearLayersButton
            setCheckedAll={setCheckedAll}
            setSwitchIsOn={setSwitchIsOn}
            checkedAll={checkedAll}
            activeLayers={activeLayers}
            layersThatWereSwitchedNames={layersThatWereSwitchedNames}
            setActiveLayers={setActiveLayers}
            setLayersThatWereSwitchedNames={setLayersThatWereSwitchedNames}
            setLayerName={setLayerName}
            setClearLayersWasClicked={setClearLayersWasClicked}
          />

          <ExternalComponentsButton />

          <Tooltip
            title={
              <span style={{ fontSize: "14px" }}>
                <b>Toggle Climatology Tab</b>
              </span>
            }
            placement="right"
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: "rgba( 83, 139, 34, 0.9)",
                  fontFamily: "Maven pro",
                  padding: "5px 10px",
                  "& .MuiTooltip-arrow": {
                    color: "rgba( 83, 139, 34, 0.9)",
                  },
                },
              },
            }}
          >
            <button
              className="layer-layer-show"
              id="layer-show-button"
              onClick={() => {
                {
                  toggleClimatologySwitcher();
                }
              }}
            >
              <FontAwesomeIcon
                icon={faTemperatureHalf}
                style={{ transform: " scale(1.5)" }}
              />
            </button>
          </Tooltip>
          <Tooltip
            title={
              <span style={{ fontSize: "14px" }}>
                <b>Google Earth Engine</b>
              </span>
            }
            placement="right"
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: "rgba( 83, 139, 34, 0.9)",
                  fontFamily: "Maven pro",
                  padding: "5px 10px",
                  "& .MuiTooltip-arrow": {
                    color: "rgba( 83, 139, 34, 0.9)",
                  },
                },
              },
            }}
          >
            <button
              className="layer-layer-show"
              id="layer-show-button"
              onClick={() => {
                {
                  toggleEarth();
                }
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
              >
                <path
                  fill="#ffffffff"
                  d="M7.853.717a1.19 1.19 0 0 0-.65.17L4.53 2.49c-.53.317-.732.984-.467 1.543l.93 1.958a9.217 9.217 0 0 0-1.745 3.076l-2.124.135A1.198 1.198 0 0 0 0 10.399v3.116a1.2 1.2 0 0 0 1.084 1.194l2.171.21a9.207 9.207 0 0 0 1.748 3.066l-.941 1.982a1.198 1.198 0 0 0 .467 1.543l2.673 1.603a1.2 1.2 0 0 0 1.605-.347l1.22-1.771a9.22 9.22 0 0 0 1.971.216c.032 0 .064-.004.096-.004a9.245 9.245 0 0 0 1.876-.212l1.22 1.77a1.2 1.2 0 0 0 1.606.348l2.673-1.603c.53-.317.732-.984.467-1.543l-.941-1.982c.022-.025.048-.049.07-.076c.066-.077.125-.159.188-.238a9.225 9.225 0 0 0 1.484-2.736l2.138-.137A1.198 1.198 0 0 0 24 13.601v-3.116a1.2 1.2 0 0 0-1.084-1.194V9.29l-2.16-.21a9.182 9.182 0 0 0-1.501-2.786c-.063-.08-.124-.16-.19-.238c-.018-.022-.039-.043-.058-.065l.93-1.958a1.198 1.198 0 0 0-.467-1.543L16.797.887a1.2 1.2 0 0 0-1.605.347L13.99 2.976a9.169 9.169 0 0 0-1.896-.219c-.033 0-.064-.004-.096-.004a9.2 9.2 0 0 0-1.992.223L8.808 1.234a1.2 1.2 0 0 0-.955-.517zm4.148 3.882c.574 0 1.13.072 1.668.197a7.41 7.41 0 0 1 5.384 4.993a7.36 7.36 0 0 1 .332 2.193c0 .764-.116 1.5-.332 2.193a7.407 7.407 0 0 1-5.384 4.992a7.393 7.393 0 0 1-1.668.199c-4.071 0-7.384-3.313-7.384-7.384c0-4.07 3.313-7.383 7.384-7.383zM11.907 6C9.558 6 8.429 7.207 8.429 7.207c3.501-1.577 5.23 2.986 6.702 4.386c1.472 1.4 2.887.203 2.887.203c-.012-.787-.252-1.533-.252-1.533c-.968.168-1.398-.494-1.97-1.252C15.224 8.253 13.561 6 11.907 6zm-3.84 3.228c-.705.015-1.3.35-1.653 1c-.868 1.601-.096 3.64-.096 3.64s.3-1.532 1.537-1.309c1.238.224 1.754 1.208 2.504 1.985c.75.776 1.895 2.064 3.978 2.064c2.082 0 3.018-1.516 3.435-2.937v-.002l-.053.04c-1.265.98-3.335.882-4.548-.275c-.89-.846-1.403-1.908-2.135-2.68c-.981-1.038-2.065-1.545-2.97-1.526z"
                />
              </svg>
            </button>
          </Tooltip>
          <Tooltip
            title={
              <span style={{ fontSize: "14px" }}>
                <b>Reset View</b>
              </span>
            }
            placement="right"
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: "rgba( 83, 139, 34, 0.9)",
                  fontFamily: "Maven pro",
                  padding: "5px 10px",
                  "& .MuiTooltip-arrow": {
                    color: "rgba( 83, 139, 34, 0.9)",
                  },
                },
              },
            }}
          >
            <button
              className="layer-layer-show"
              id="layer-show-button"
              onClick={() => {
                {
                  goToWebGIS();
                }
              }}
            >
              <FontAwesomeIcon
                icon={faArrowRotateLeft}
                style={{ transform: " scale(1.5)" }}
              />
            </button>
          </Tooltip>

          <button
            className="left-side-toggle-button"
            onClick={toggleLeftButtons}
          >
            <FontAwesomeIcon
              icon={leftButtonsVisible ? faChevronLeft : faChevronRight}
            />
          </button>
          {/* </div> */}
        </div>
        <LayerSearchbar onSearchTermChange={handleSearchTermChange} />

        <div
          className="layer-selector-container"
          style={{ left: layerLeftValue }}
        >
          {/* <JSONToDivs
            jsonData={jsonTitleParts}
            setLayerName={setLayerName}
            setSwitchIsOn={setSwitchIsOn}
            setShowTooltip={setShowTooltip}
            setLayerOpacity={setLayerOpacity}
            setBoundingBox={setBoundingBox}
            setButtonOn={setButtonOn}
            checkedAll={checkedAll}
            setCheckedAll={setCheckedAll}
            setLayersThatWereSwitchedNames={setLayersThatWereSwitchedNames}
            layersThatWereSwitchedNames={layersThatWereSwitchedNames}
          /> */}
          <FolderLayout
            fileStructure={jsonTitleParts}
            setLayerName={setLayerName}
            setSwitchIsOn={setSwitchIsOn}
            setShowTooltip={setShowTooltip}
            setLayerOpacity={setLayerOpacity}
            setBoundingBox={setBoundingBox}
            setButtonOn={setButtonOn}
            checkedAll={checkedAll}
            setCheckedAll={setCheckedAll}
            setLayersThatWereSwitchedNames={setLayersThatWereSwitchedNames}
            layersThatWereSwitchedNames={layersThatWereSwitchedNames}
            activeLayers={activeLayers}
            setActiveLayers={setActiveLayers}
          />
          <ExternalComponentsLayers />
        </div>
        <div
          className="point-clouds-comp-container"
          style={{ bottom: bottomValue }}
        >
          <div
            className="point-clouds-comp-container-2"
            // style={{ bottom: bottomValue }}
          >
            <Pointclouds pointClouds={pointClouds} />
          </div>
        </div>
        <FeatureInfo
          activeLayers={activeLayers}
          activeLayersTitles={layersThatWereSwitchedNames}
        />
        <Tooltip
          title={
            <span style={{ fontSize: "14px" }}>
              <b>Change Map Style</b>
            </span>
          }
          placement="left"
          arrow
          componentsProps={{
            tooltip: {
              sx: {
                bgcolor: "rgba( 83, 139, 34, 0.9)",
                fontFamily: "Maven pro",
                padding: "5px 10px",
                "& .MuiTooltip-arrow": {
                  color: "rgba( 83, 139, 34, 0.9)",
                },
              },
            },
          }}
        >
          <button
            className="chevron-layer"
            id={`layer-styling-button`}
            style={{ transform: "rotate(0deg)" }}
            onClick={() => {
              {
                toggleStyleSwitcher();
              }
            }}
          >
            <FontAwesomeIcon icon={faMap} />
          </button>
        </Tooltip>

        <div className="style-switcher-container" style={{ left: leftValue }}>
          <StyleSwitcher />
        </div>
        {activeLayers.length > 0 && (
          <LayerLegend
            activeLayers={activeLayers}
            layersThatWereSwitchedNames={layersThatWereSwitchedNames}
            clearLayersWasClicked={clearLayersWasClicked}
            setClearLayersWasClicked={setClearLayersWasClicked}
          />
        )}
      </div>
      <Funding />
    </div>
  );
}

export default WebGIS;
